import { IRole, RoleAuthTarget } from '@boma/client-shared';
import { createAction, props } from '@ngrx/store';
import { ICreateOrUpdateEntityRoleRequest } from '@boma/supplier-portal/shared/services';

export const loadRoles = createAction(
  '[Roles] Load Entity Roles',
  props<{ target: RoleAuthTarget }>()
);

export const setSelectedRole = createAction(
  '[Roles] Set Selected Role',
  props<{ roleId: string }>()
);

export const loadEntityRoleDetails = createAction(
  '[Roles] Load Entity Role',
  props<{ id: string }>()
);

export const loadEntityRoleDetailsSuccess = createAction(
  '[Roles] Load Entity Role Success',
  props<{ role: IRole }>()
);

export const loadEntityRoleDetailsFailure = createAction(
  '[Roles] Load Entity Role Failure',
  props<{ error: any }>()
);

export const loadEntityRolesSuccess = createAction(
  '[Roles] Load Entity Roles Success',
  props<{ payload: IRole[] }>()
);

export const loadLocationRolesSuccess = createAction(
  '[Roles] Load Location Roles Success',
  props<{ payload: IRole[] }>()
);

export const loadVehicleRolesSuccess = createAction(
  '[Roles] Load Vehicle Roles Success',
  props<{ payload: IRole[] }>()
);

export const loadRolesFailure = createAction(
  '[Roles] Load Roles Failure',
  props<{ error: any }>()
);

export const loadAssignedAdminRoles = createAction(
  '[Roles] Load User Admin Roles',
  props<{ userId: string }>()
);

export const loadAssignedAdminRolesSuccess = createAction(
  '[Roles] Load User Admin Roles Success',
  props<{ payload: IRole[] }>()
);

export const loadAssignedAdminRolesFailure = createAction(
  '[Roles] Load Roles Failure',
  props<{ error: any }>()
);

export const applyAssignedAdminRoles = createAction(
  '[Roles] Apply User Admin Roles',
  props<{ userId: string; roles: string[] }>()
);

export const applyUserRoles = createAction(
  '[Roles] Apply User Roles',
  props<{ userId: string; roles: { roleId: string; targetId?: string }[] }>()
);

export const applyAssignedAdminRolesSuccess = createAction(
  '[Roles] Apply User Admin Roles Success',
  props<{ payload: IRole[] }>()
);

export const applyAssignedAdminRolesFailure = createAction(
  '[Roles] Apply Roles Failure',
  props<{ error: any }>()
);

export const createEntityRole = createAction(
  '[Roles] Create Entity Role',
  props<{ request: ICreateOrUpdateEntityRoleRequest }>()
);

export const updateEntityRole = createAction(
  '[Roles] Update Entity Role',
  props<{ roleId: string; request: ICreateOrUpdateEntityRoleRequest }>()
);

export const modifyEntityRolesSuccess = createAction(
  '[Roles] Modify Entity Roles Success',
  props<{ payload: IRole }>()
);

export const modifyEntityRolesFailure = createAction(
  '[Roles] Modify Entity Roles Failure',
  props<{ error: any }>()
);
